@if (client) {
  <div class="container-fluid p-3 border rounded bg-light mb-3">
    <div class="d-flex justify-content-between align-items-start">
      <h3>{{ client.fullName || client.name }}</h3>

      <div class="text-end">
        <button
          type="button"
          class="btn"
          [class.btn-success]="approvedForProcessing"
          [class.btn-outline-success]="!approvedForProcessing"
          [disabled]="savingApproval"
          (click)="toggleApprovedForProcessing()">
          {{ approvedForProcessing ? 'Approved' : 'Approve for Processing' }}
        </button>

        @if (approvedForProcessing) {
          <div class="small text-muted">
            Approved by {{ client.approvedForProcessingByDisplay }} on {{ client.approvedForProcessingAt | date:'MM/dd/yyyy h:mm a' }}
          </div>
        }
      </div>
    </div>

    <div class="row">
      <div class="col-2 mb-2">
        <label>Short Name</label>
        <div>{{ client.name | blankValueDash }}</div>
      </div>
      <div class="col-3 mb-2">
        <label>EHR Systems</label>
        <div>{{ emrSystemNames | blankValueDash }}</div>
      </div>
      <div class="col-3 mb-2">
        <label>Allowed EHR Instances</label>
        <div>{{ allowedEhrInstanceValues | blankValueDash }}</div>
      </div>
      <div class="col-4 mb-2">
        <label>HRSA IDs</label>
        <div>{{ hrsaIds | blankValueDash }}</div>
      </div>
    </div>
  </div>
}

@if (!loading) {
  <div class="row">

    <div class="col-6">
      <h4>File Quality Checks</h4>
      <div class="chore-list-scroll">
        <table class="table table-bordered table-hover table-fixed-header chore-list">
          <thead class="table-dark">
            <tr>
              <th>ID</th>
              <th>Date</th>
              <th>Note</th>
              <th>Includes</th>
              <th>Chore Status</th>
              <th>Checklist Status</th>
            </tr>
          </thead>
          @if (visibleClientChores.length > 0) {
            <tbody>
              @for (clientChore of visibleClientChores; track clientChore.id) {
                @if (clientChore === extraChore) {
                  <tr class="chore-gap">
                    <td colspan="99">&hellip;</td>
                  </tr>
                }
                <tr
                  class="chore-row"
                  [routerLink]="choreLink(clientChore)"
                  [queryParams]="choreLinkQueryParams(clientChore)"
                  [class.table-active]="clientChore === selectedChore">
                  <td>{{ clientChore.id }}</td>
                  <td class="text-nowrap">{{ clientChore.createdAt | date:'MM/dd/yyyy' }}</td>
                  <td>
                    @if (clientChore.notes) {
                      <div class="phi notes">{{ clientChore.notes }}</div>
                    }
                  </td>
                  <td>
                    <div>{{ clientChore.displayParams | blankValueDash }}</div>
                  </td>
                  <td>
                    <app-client-chore-status [clientChore]="clientChore" />
                  </td>
                  <td>
                    @if (clientChore.checklistStatus) {
                      <span
                        class="badge fw-normal checklist-status"
                        [class.bg-success]="clientChore.checklistStatus === 'pass'"
                        [class.bg-danger]="clientChore.checklistStatus === 'fail'">
                        <mat-icon>{{ clientChore.checklistStatus === 'pass' ? 'check' : 'close' }}</mat-icon>
                        {{ clientChore.checklistStatus | uppercase }}
                      </span>
                      <div class="small text-muted">by {{ clientChore.checklistStatusByDisplay }}</div>
                    } @else {
                      --
                    }
                  </td>
                </tr>
              }
            </tbody>
          } @else {
            <tbody>
              <tr>
                <td colspan="99">There are no client EHR file reviews for this client.</td>
              </tr>
            </tbody>
          }
        </table>
      </div>

      @if (hasMoreChores) {
        <button type="button" class="btn btn-link p-0" [disabled]="loadingAllChores" (click)="showAllChores()">
          View All
        </button>
      }
    </div>

    <div class="col-6">
      @if (loadingChecklist) {
        <mat-spinner />
      } @else if (checklist) {
        <div class="d-flex justify-content-between align-items-center gap-3 mb-3">
          <h4 class="mb-0">File Quality Checklist #{{ selectedChore.id }}</h4>

          <div class="d-flex align-items-center gap-2 checklist-actions">
            @if (selectedChore.reportExpirableDownloadPath) {
              <button type="button" class="btn btn-outline-dark btn-sm" (click)="downloadReport()">
                <mat-icon>file_download</mat-icon>
                Download Report
              </button>
            }

            <button
              type="button"
              class="btn btn-sm"
              [class.btn-danger]="selectedChore.checklistStatus === 'fail'"
              [class.btn-outline-danger]="selectedChore.checklistStatus !== 'fail'"
              [disabled]="savingChecklistStatus"
              (click)="setChecklistStatus('fail')">
              <mat-icon>close</mat-icon>
              Fail
            </button>

            <button
              type="button"
              class="btn btn-sm"
              [class.btn-success]="selectedChore.checklistStatus === 'pass'"
              [class.btn-outline-success]="selectedChore.checklistStatus !== 'pass'"
              [disabled]="savingChecklistStatus"
              (click)="setChecklistStatus('pass')">
              <mat-icon>check</mat-icon>
              Pass
            </button>
          </div>
        </div>

        @if (checklist.empty) {
          <p class="text-muted">No checklist associated with this review.</p>
        } @else {
          <app-client-file-quality-checklist [checklist]="checklist" />
        }
      } @else if (clientChores.length > 0) {
        <p class="text-muted">Select a review to see its checklist.</p>
      }
    </div>

  </div>
} @else {
  <mat-spinner />
}
